/**
 * Content Hero Banner Component
 * Handles slide-in animations for hero banner text content
 */

(function() {
  class ContentHeroBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Check if animations are enabled
      const heroBanner = this.querySelector('.content-hero-banner');
      const heroContent = this.querySelector('.hero-content');

      if (!heroContent) return;

      // Check animation setting from data attribute
      const animationEnabled = heroBanner?.getAttribute('data-animate') === 'true';

      if (animationEnabled) {
        // Trigger animation when element becomes visible using Intersection Observer
        this.observeElementVisibility(heroContent);
      }
    }

    observeElementVisibility(element) {
      // Use Intersection Observer to trigger animation when element enters viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Force browser to reflow and trigger animation
            void entry.target.offsetHeight;
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '0px'
      });

      observer.observe(element);
    }

    disconnectedCallback() {
      // Cleanup if needed
    }
  }

  // Register the custom element
  if (!customElements.get('content-hero-banner')) {
    customElements.define('content-hero-banner', ContentHeroBanner);
  }
})();
